module.exports = __webpack_public_path__ + "img/status.a13e4a48.svg";